<arm-dialog (onCancel)="onCancel()" (onSubmit)="onSubmit()" [title]="'Advanced Search'">
  <div class="search-container">
    <div class="search-column">

      <mat-form-field>
        <mat-label>Group name</mat-label>
        <input [(ngModel)]="search.groupName" matInput name="group-name">
      </mat-form-field>

      <mat-form-field>
        <mat-label>Element name</mat-label>
        <input [(ngModel)]="search.elementName" matInput name="serial">
      </mat-form-field>

      <ac-input-container label="Type"   >
        <ac-select
          [(acModel)]="search.type"
          [items]="search.typeOptions"
          [allowClear]="true"
          [multiple]="false"
          [bindValue]="'value'"
          [bindLabel]="'text'">
        </ac-select>
      </ac-input-container>

    </div>
  </div>
</arm-dialog>

